import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
	children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
	const token = localStorage.getItem('HRMS-token');
	return token ? children : <Navigate to='/' replace />;
};

export default ProtectedRoute;
